/**
 * HowItWorksSection - 작동 방식 섹션
 *
 * 서비스 이용 방법을 3단계로 간단하게 설명
 * 1. 시중 문제집 선택
 * 2. 학생에게 배정
 * 3. 학생이 답 제출 → 즉시 채점
 */

import React from 'react';
import { Typography, Steps, Card } from 'antd';
import {
  BookOutlined,
  TeamOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

// 단계 데이터
const steps = [
  {
    icon: <BookOutlined style={{ fontSize: '24px' }} />,
    title: '문제집 선택',
    description: '이미 등록된 시중 문제집 중에서 사용할 문제집을 선택하세요.',
  },
  {
    icon: <TeamOutlined style={{ fontSize: '24px' }} />,
    title: '학생에게 배정',
    description: '담당 학생에게 문제집을 배정합니다. 학생은 채점봇에서 문제를 풀어요.',
  },
  {
    icon: <CheckCircleOutlined style={{ fontSize: '24px' }} />,
    title: '즉시 채점',
    description: '학생이 답을 제출하면 바로 채점! 결과는 강사 대시보드에서 확인하세요.',
  },
];

export const HowItWorksSection: React.FC = () => {
  return (
    <section
      style={{
        background: '#f8f9fa',
        padding: '80px 24px',
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* 섹션 제목 */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <Text
            style={{
              color: '#52c41a',
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            How it works
          </Text>
          <Title
            level={2}
            style={{
              marginTop: '8px',
              marginBottom: '16px',
              fontSize: 'clamp(24px, 4vw, 36px)',
            }}
          >
            간단한 3단계로 시작
          </Title>
        </div>

        {/* Steps */}
        <Card
          bordered={false}
          style={{
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          }}
          bodyStyle={{ padding: '40px' }}
        >
          <Steps
            direction="vertical"
            current={-1}
            items={steps.map((step, index) => ({
              title: (
                <Text strong style={{ fontSize: '18px' }}>
                  {step.title}
                </Text>
              ),
              description: (
                <Text
                  type="secondary"
                  style={{
                    fontSize: '15px',
                    lineHeight: 1.7,
                    display: 'block',
                    paddingBottom: index < steps.length - 1 ? '24px' : '0',
                  }}
                >
                  {step.description}
                </Text>
              ),
              icon: (
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                  }}
                >
                  {step.icon}
                </div>
              ),
            }))}
          />
        </Card>

        {/* 추가 안내 */}
        <div
          style={{
            textAlign: 'center',
            marginTop: '32px',
            padding: '20px',
            background: '#fff',
            borderRadius: '12px',
            border: '1px dashed #d9d9d9',
          }}
        >
          <Text style={{ fontSize: '15px', color: '#666' }}>
            원하시는 문제집이 없나요? 아래 이메일로 요청해주시면 등록해드립니다.
          </Text>
          <br />
          <Text
            copyable
            style={{
              fontSize: '16px',
              color: '#667eea',
              fontWeight: 600,
              marginTop: '8px',
              display: 'inline-block',
            }}
          >
            dashiki78@gmail.com
          </Text>
        </div>
      </div>
    </section>
  );
};
